import React, { Component } from 'react'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import { Stack, Row, Col } from 'react-bootstrap'

class Random extends Component {
  componentDidMount() {
    axios.get('/api/random')
      .then(res => {
        const { id, index } = res.data
        this.props.history.replace(`/single?id=${id}&index=${index}`)
      })
      .catch(() => {
        this.props.history.replace('/')
      })
  }

  render() {
    return (
      <Stack gap={3}>
        <Row>&nbsp;</Row>
        <Row><Col className="text-center">Finding a random text...</Col></Row>
      </Stack>
    )
  }
}

export default withRouter(Random)
